var hostname = process.env.HOSTNAME || '';
// disable redis caching on beta, if matches beta set to false
var redisCacheEnabled = !/^beta/.test(hostname);

module.exports = {
    redisCache: {
        enabled: redisCacheEnabled
    },
    piwikEnabled: false,
    pollsEnabled: true
};
